import { render, staticRenderFns } from "./rezervasyonDetay.vue?vue&type=template&id=f46c7bf6&scoped=true&"
import script from "./rezervasyonDetay.vue?vue&type=script&lang=js&"
export * from "./rezervasyonDetay.vue?vue&type=script&lang=js&"
import style0 from "./rezervasyonDetay.vue?vue&type=style&index=0&id=f46c7bf6&lang=scss&scoped=true&"
import style1 from "./rezervasyonDetay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46c7bf6",
  null
  
)

export default component.exports